module.exports = __webpack_public_path__ + "media/images/icons/x-adbd065e123bfca6984463809795b8da.svg";